import Vue from 'vue'
import Vuex from 'vuex'
import routes from './routes/routes.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logined: false,
    name: ''
  },
  mutations: {
    setName(state, newName) {
      state.name = newName

    },
    login(state) {
      state.logined = true
    },
    logout(state) {
      state.logined = false

      localStorage.removeItem('access')
      localStorage.removeItem('refresh')

      location.pathname = '/'
    }
  }
})
